import React, { useEffect } from "react"
import { Container, Col } from "react-bootstrap"
import { useSelector, useDispatch, shallowEqual } from "react-redux"
import PolicyInformation from "./policyInformation"
import RequiredDocuments from "./requiredDocuments"
import LossDetails from "./lossDetails"
import ClaimsPayout from "./claimsPayout"
import ReviewClaim from "./reviewClaim"
import SubmittedClaim from "./submittedClaim"

import * as API from "../../services/httpService"
import { updateFromGetData, updateUiData } from "../../redux/actions"
// import { navigate } from "gatsby"

const BaseForm = () => {
  const uiData = useSelector(state => state.uiData)
  const { maxPageNumber } = uiData
  const claimData = useSelector(state => state.claimData, shallowEqual)

  // useEffect(() => {}, shallowEqual)
  const dispatch = useDispatch()
  useEffect(() => {
    API.apiPostRequest("/Claim/GetData", null, null).then(function(response) {
      let actionList = []
      if (response.data.policyNumber) {
        actionList.push(
          updateFromGetData("policyNumber", response.data.policyNumber)
        )
      }
      if (response.data.policyHolderName) {
        actionList.push(
          updateFromGetData("policyHolderName", response.data.policyHolderName)
        )
      }
      // if (response.data.policyHolderNric) {
      //   actionList.push(
      //     updateValidFormData(
      //       "policyHolderNric",
      //       response.data.policyHolderNric
      //     )
      //   )
      // }
      if (response.data.claimantEmail) {
        actionList.push(
          updateFromGetData("policyHolderEmail", response.data.claimantEmail)
        )
      }
      if (response.data.claimantMobile) {
        actionList.push(
          updateFromGetData("policyHolderTel", response.data.claimantMobile)
        )
      }

      if (response.data.sourceSystem) {
        actionList.push(
          updateFromGetData("sourceSystem", response.data.sourceSystem)
        )
      }

      if (response.data.hideHeaderFooter?.toLowerCase() == "true") {
        dispatch(updateUiData("hideHeaderFooter", true))
      }

      actionList.forEach((action, actionKey) => {
        dispatch(action)
      })
    })
  }, [])

  return (
    <>
      <Container className="body-content mt-md-4">
        {/* Pages
          1. Policy Information + Claimant Details
          2. Upload Required Documents
          3. Loss Details
          4. Claims Payout Instruction
          5. Summary
          6. Submitted Result
        */}

        <Col xs={12}>
          {/* 5. Summary */}
          {maxPageNumber >= 5 && (
            <ReviewClaim claimData={claimData} uiData={uiData} />
          )}

          {/* 1. Policy Information + Claimant Details */}
          {maxPageNumber >= 1 && (
            <PolicyInformation claimData={claimData} uiData={uiData} />
          )}

          {/* 2. Upload Required Documents */}
          {maxPageNumber >= 2 && (
            <RequiredDocuments claimData={claimData} uiData={uiData} />
          )}

          {/* 3. Loss Details */}
          {maxPageNumber >= 3 && (
            <LossDetails claimData={claimData} uiData={uiData} />
          )}

          {/* 4. Claims Payout Instruction */}
          {maxPageNumber >= 4 && (
            <ClaimsPayout claimData={claimData} uiData={uiData} />
          )}

          {/* 6. Submitted Result */}
          {maxPageNumber === 6 && (
            <SubmittedClaim uiData={uiData}></SubmittedClaim>
          )}
        </Col>
      </Container>
    </>
  )
}

export default BaseForm
